import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { localize } from 'core/localization';
import { RootAppState } from 'store/types';
import Trophy from 'assets/figures/Trophy';
import { Text, Button } from 'components/common';
import { getLearnServiceUrl, isPreviewMode, isReviewMode } from 'store/settings/selectors';
import * as navigationActions from 'store/navigation/actions';
import { isLtiInitialized } from 'store/modules/selectors';
import { Figure, TextElement, ButtonsWrapper, Wrapper } from './ThankForFeedback.styled';
import { isGuestUser } from 'store/user/selectors';

type ThankForFeedbackProps = {
  backTo(): void;
  closeCourse(): void;
  fromDownloadCertificateButton: boolean;
  isScormMode: boolean;
  isLti: boolean;
  previewMode: boolean;
  reviewMode?: boolean;
  learnServiceUrl?: string;
  navigationActions: { [key: string]: any };
  isGuestUser?: boolean;
};

export class ThankForFeedback extends React.PureComponent<ThankForFeedbackProps, {}> {
  static defaultProps = {
    fromDownloadCertificateButton: false,
    isScormMode: false,
    previewMode: false
  };

  render() {
    const {
      fromDownloadCertificateButton,
      backTo,
      closeCourse,
      isScormMode,
      isLti,
      previewMode,
      navigationActions,
      learnServiceUrl,
      reviewMode,
      isGuestUser
    } = this.props;

    return (
      <Wrapper>
        <Figure>
          <Trophy />
        </Figure>
        <Text appearance="h3">{localize('[thank for feedback]')}</Text>
        {!isScormMode && !previewMode && !fromDownloadCertificateButton && (
          <Wrapper>
            <TextElement appearance="p" size={20} font="secondaryFont">
              {isLti || reviewMode || isGuestUser
                ? localize('[close lti course text]')
                : localize('[close course text]')}
            </TextElement>
            {!isLti && !reviewMode && !isGuestUser && (
              <ButtonsWrapper>
                <Button
                  data-test="my-courses-button"
                  onClick={() => navigationActions.goToUrl(learnServiceUrl)}
                  layout="primary"
                  tabIndex={1}
                >
                  {localize('[my courses]')}
                </Button>
              </ButtonsWrapper>
            )}
          </Wrapper>
        )}

        {isScormMode && (
          <ButtonsWrapper>
            <Button onClick={closeCourse} layout="secondary" tabIndex={0}>
              {localize('[close course]')}
            </Button>
          </ButtonsWrapper>
        )}

        {fromDownloadCertificateButton && (
          <Wrapper>
            <TextElement appearance="p" size={20} font="secondaryFont">
              {localize('[close course text]')}
            </TextElement>
            <ButtonsWrapper>
              {!isLti && !isGuestUser && (
                <Button
                  onClick={() => navigationActions.goToUrl(learnServiceUrl)}
                  layout="primary"
                  tabIndex={1}
                >
                  {localize('[my courses]')}
                </Button>
              )}
              <Button onClick={backTo} layout="primary" tabIndex={1}>
                {localize('[back to the results]')}
              </Button>
            </ButtonsWrapper>
          </Wrapper>
        )}
      </Wrapper>
    );
  }
}

function mapStateToProps(state: RootAppState) {
  return {
    learnServiceUrl: getLearnServiceUrl(state),
    previewMode: isPreviewMode(state),
    reviewMode: isReviewMode(state),
    isLti: isLtiInitialized(state),
    isGuestUser: isGuestUser(state)
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    navigationActions: bindActionCreators(navigationActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ThankForFeedback);
